import platform from './platform';

export const BGM_ZPP_COURSE_OFFER_IDS = {
  dakBgm: {
    sda: platform.isProduction
      ? '2C4CCA94B046CE2DF4A4193439768C9D4F4DB406F3E426FFE316B13D4AA8F646'
      : 'A4D5545DDD2DD536186256968C614B4CAA709903FA1A620A6F94E4D7ACB517B5'
  },
  hkkBgm: {
    sda: platform.isProduction
      ? '2C4CCA94B046CE2DF4A4193439768C9D4F4DB406F3E426FFB854ECA279D5CD80'
      : 'A4D5545DDD2DD536186256968C614B4CAA709903FA1A620A90FA04AA56E1EC67'
  }
};
